var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEdit(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 18,
    height: 18,
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    fill: "currentColor"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M15.98 5.889L19.11 9.02c.132.132.132.347 0 .479l-7.583 7.583-3.222.358c-.431.049-.796-.316-.747-.747l.358-3.222L15.5 5.89c.132-.132.347-.132.48 0zm5.624-.795L19.91 3.399c-.528-.527-1.386-.527-1.917 0l-1.23 1.23c-.131.131-.131.347 0 .479l3.133 3.132c.132.132.347.132.479 0l1.23-1.23c.527-.53.527-1.388 0-1.916zm-6.27 9.927v3.535H4.221V7.444h7.98c.11 0 .215-.045.295-.121l1.388-1.389c.264-.264.077-.712-.295-.712H3.667C2.747 5.222 2 5.97 2 6.89V19.11c0 .92.747 1.667 1.667 1.667h12.222c.92 0 1.667-.747 1.667-1.667v-5.48c0-.37-.448-.555-.712-.294l-1.39 1.389c-.076.08-.12.184-.12.295z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEdit);
export default __webpack_public_path__ + "static/media/edit.e3d6276f2912b6d006ba7ad818aedc27.svg";
export { ForwardRef as ReactComponent };